<script>
    import { Pie, mixins } from 'vue-chartjs';
    const tinycolor = require('tinycolor2')
    export default {
        mounted() {
            if (this.render_info && !this.render_info.display_extra) {
              this.options.legend.display = false
            }
            this.draw()
        },
        props: ['chartData','height','width','render_info'],
        extends: Pie,
        mixins: [mixins.reactiveProp],
        watch: {
            chartData: function () {
                this.draw()
            },
        },
        methods: {
            draw() {
                this.setThreshold()
                this.renderChart(this.chartData,this.options)
            },
            commarize(number) {
                let min = 1e3;
                // Alter numbers larger than 1k
                if (number >= min) {
                    var units = ["k", "M", "B", "T", "Q"];

                    var order = Math.floor(Math.log(number) / Math.log(1000));

                    var unitname = units[(order - 1)];
                    var num = Math.floor(number / 1000 ** order);

                    // output number remainder + unitname
                    return num + unitname
                }

                // return formatted original number
                return number.toLocaleString()
            },
            setThreshold() {
              // Need to fix this line, for when there's no chartData?
                let sizes = this.chartData.datasets[0].data
                let first_value = sizes[0]
                let last_value = sizes[sizes.length-1] // "OTHER" could be the max
                let max = first_value
                if (first_value < last_value) {
                    max = last_value
                }
                this.label_threshold = max / 20;
            },
        },
        data() {
            return {
                label_threshold: null,
                options: {
                    onClick: (e) => {
                        let element_index = this.$data._chart.getElementAtEvent(e)[0]._index
                        let label = this.$data._chart.data.labels[element_index]
                        this.$emit('stackChartClicked', {label: label});
                    },
                    legend: {
                        display: true,
                        position: 'left',
                    },
                    plugins: {
                        datalabels: {
                            align: 'end',
                            labels: {
                                title: true,
                            },
                            display: (context) => {
                                if (this.width < (1108 / 2)) return false;
                                else return true;
                            },
                            color: (context) => {
                                let value = this.chartData.datasets[0].data[context.dataIndex]
                                let color_as_hex = this.chartData.datasets[0].backgroundColor[context.dataIndex]
                                if (value <= this.label_threshold) {
                                    return tinycolor(color_as_hex).darken(20);
                                }
                                let brightness_as_percent = tinycolor(color_as_hex).getBrightness() / 255
                                if (brightness_as_percent > 0.6) {
                                    return('black');
                                } else if (brightness_as_percent > 0.4) {
                                    return('yellow');
                                } else {
                                    return('white');
                                }
                            },
                            formatter: (value, context) => {
                                if (value <= this.label_threshold) {
                                    return this.chartData.labels[context.dataIndex] + ' (' + this.commarize(value) + ')';
                                } else {
                                    return this.commarize(value)
                                }
                            },
                            anchor: (context) => {
                                let value = this.chartData.datasets[0].data[context.dataIndex]
                                if (value <= this.label_threshold) return 'end';
                                else return 'middle';
                            }
                        }
                    }
                }
            }
        },
    }
</script>

